// removed by extract-text-webpack-plugin
module.exports = {"currentUser":"_3coopPnTXHpkoFZore5KjL","name":"_4cICMR3N3Ymme5f1ip5rq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CurrentUser/style.css
// module id = 280
// module chunks = 0